// tailwind.config.js
import colors from 'tailwindcss/colors.js'

export default {
    future: {
        removeDeprecatedGapUtilities: true,
        purgeLayersByDefault: true,
    },
    content: [
        './resources/**/*.blade.php',
        './resources/**/*.js',
        './resources/**/*.jsx',
        './resources/**/*.ts',
        './resources/**/*.tsx',
        './stories/**/*.js',
        './stories/**/*.jsx',
        './stories/**/*.ts',
        './stories/**/*.tsx',
        './.storybook/**/*.ts',
        './.storybook/**/*.tsx',
    ],
    theme: {
        extend: {
            keyframes: {
                'slide-in': {
                    '0%': { transform: 'translateX(-100%)' },
                    '100%': { transform: 'translateX(0)' },
                },
                'slide-out': {
                    '0%': { transform: 'translateX(0)' },
                    '100%': { transform: 'translateX(-100%)' },
                },
                // Nav v2: subtle icon swap when the pin/unpin state toggles.
                // The icon scales down + fades briefly, then springs back.
                'nav-pin-pop': {
                    '0%': { transform: 'scale(0.7)', opacity: '0' },
                    '60%': { transform: 'scale(1.08)', opacity: '1' },
                    '100%': { transform: 'scale(1)', opacity: '1' },
                },
            },
            animation: {
                'slide-in': 'slide-in 0.2s ease-in',
                'slide-out': 'slide-out 0.15s ease-out',
                'nav-pin-pop': 'nav-pin-pop 90ms cubic-bezier(0.34, 1.56, 0.64, 1)',
            },
            borderWidth: {
                '1': '1px',
                '3': '3px',
            },
            transitionProperty: {
                'height': 'height',
            },
            colors: {
                state: {
                    'paused': '#FFC833',
                },
                blue: colors.blue,
                // lightBlue: colors.lightBlue,
                emerald: colors.emerald,
                amber: colors.amber,
                teal: colors.teal,
                green: colors.green,
                gray: colors.gray,
                ochre: {
                    50: '#F6E5D4',
                    100: '#F2D9BF',
                    200: '#EABF94',
                    300: '#E1A66A',
                    400: '#D98D3F',
                    500: '#BF7326',
                    600: '#94591E',
                    700: '#6A4015',
                    800: '#3F260D',
                    900: '#150D04',
                },
                mjGreen: {
                    100: '#D4F5EF',
                    200: '#A9EBDF',
                    300: '#7EE0D0',
                    400: '#53D6C0',
                    500: '#28CCB0',
                    600: '#24B89E',
                    700: '#20A38D',
                },
                mjRed: {
                    100: '#FFD6D6',
                    200: '#FFADAD',
                    300: '#FF8585',
                    400: '#FF5C5C',
                    500: '#FF3333',
                    600: '#CC2929',
                    700: '#991F1F',
                },
                mjBlue: {
                    100: '#D6E9FF',
                    200: '#ADD3FF',
                    300: '#85BDFF',
                    500: '#3391FF',
                    600: '#2974CC',
                },
                mjDark: {
                    600: '#899CB3',
                    700: '#7289A3',
                    800: '#5A7594',
                    1000: '#2B4E75',
                    1400: '#0E2947',
                },
                mjGray: {
                    300: '#F1F3F6',
                    400: '#EAEDF1',
                    600: '#DBE2E8',
                    800: '#CDD6DF',
                    1000: '#BFCAD6',
                },
            },
        },
    },
    variants: {},
    plugins: [],
}
